<template>
    <div class="left_panel">
        <div
            class="panel_head_wrap d-flex align-items-end justify-content-between"
        >
            <div class="panel_heading">
                <h2>Saved Designs</h2>
                <div class="subhead">
                    Manage your designs from DESIGN STUDIO
                </div>
            </div>
            <div
                class="panel_head_right upload_img_panel d-flex align-items-center"
            >
                <div
                    v-if="imageIds.length > 0"
                    class="select_checkbox form-check pl_8 py_6"
                >
                    <label class="checkbox_custom font_size_20"
                        >Select All
                        <input
                            type="checkbox"
                            @click="selectAll"
                            v-model="allSelected"
                        />
                        <span class="checkmark"></span>
                    </label>
                </div>

                <div
                    v-if="imageIds.length > 0"
                    style="cursor: pointer"
                    @click="deleteImages()"
                    class="delet_icon"
                >
                    <span class="bin_icon">
                        <img
                            alt=""
                            src="/maincss/images/icons/delete_dark.svg"
                        />
                    </span>
                    <span class="font_size_20">Delete</span>
                </div>
            </div>
        </div>

        <!-- here we can add popup for preview images -->
        <div
            v-if="
                getUrlExtension(preview_artwork_images) != 'ai' &&
                getUrlExtension(preview_artwork_images) != 'eps'
            "
            class="modal fade cart_preview"
            id="preview_modals"
            data-backdrop="static"
            data-keyboard="false"
            tabindex="-1"
            aria-labelledby="staticBackdropLabel"
            aria-hidden="true"
        >
            <div
                class="modal-dialog modal-dialog-centered modal-xl large_popup upload_img_popup"
            >
                <div class="modal-content">
                    <div class="modal-header border-bottom-0 p-0">
                        <button
                            type="button"
                            class="close py-2 pr-3"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <img src="/maincss/images/cancel.svg" />
                        </button>
                    </div>
                    <div class="modal-body pt-0">
                        <div
                            v-if="
                                getUrlExtension(preview_artwork_images) == 'pdf'
                            "
                            class="mx-auto preview-image mb_20"
                        >
                            <iframe
                                :src="preview_artwork_images"
                                width="500px"
                                height="300px"
                            ></iframe>
                        </div>
                        <div v-else class="mx-auto preview-image mb_20">
                            <img :src="preview_artwork_images" alt="" />
                        </div>
                        <div class="mx-auto preview-image">
                            <!-- <button class="btn btn_orange bg_primary_orange text_white" type="button" @click="downloadArtwork(item.NewOrderItemDecoration ? item.NewOrderItemDecoration.final_proof_image : '', 'FinalProofImage', index)">Download</button> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="upload_img_wrap image-eyeicon">
            <div
                class="row"
                v-if="!uploadedImages || uploadedImages.length == 0"
            >
                <span>No records found.</span>
            </div>
            <div class="row">
                <div
                    v-for="(image, ind) in uploadedImages"
                    :key="ind"
                    class="col"
                >
                    <div class="upload_img_cont position-relative">
                        <button
                            class="add_artwork_preview_popup_btn seen"
                            data-toggle="modal"
                            data-target="#preview_modals"
                            @click="previewArtworkImages(image)"
                        >
                            <img src="/maincss/images/preview.svg" alt="" />
                        </button>
                        <a href="#">
                            <div class="form-check pl_8 py_6">
                                <label class="checkbox_custom"
                                    ><input
                                        type="checkbox"
                                        v-model="imageIds"
                                        @click="select"
                                        :value="image.id" /><span
                                        class="checkmark"
                                    ></span
                                ></label>
                            </div>
                            <div
                                class="up_img text-center bg_primary_light_white"
                            >
                                <img :src="image.front_image" />
                            </div>
                            <div class="up_text mt_16 ml_10 mb_40">
                                <div class="font_size_17">{{ image.name }}</div>
                                <!-- <p class="font_size_12 text_light_grey">{{ image.image_dimension }} - {{ image.image_size }}</p> -->
                            </div>
                        </a>
                    </div>
                </div>
            </div>
            <b-pagination
                v-show="total_uploaded_images > 0 && item_length > itemsPerPage"
                v-model="currentPage"
                :total-rows="item_length"
                :per-page="itemsPerPage"
                class="imprint_pagination"
            ></b-pagination>
        </div>
        <div class="preloader" v-show="isLoader">
            <div class="preloader-body">
                <svg width="40" height="40" viewBox="0 0 40 40">
                    <polygon
                        class="rect"
                        points="0 0 0 40 40 40 40 0"
                    ></polygon>
                </svg>
            </div>
        </div>
    </div>
</template>
<script>
import { fabric } from "fabric";
import ApiService from "@/common/api.service";
import { LOGOUT } from "@/store/actions.type";

export default {
    name: "my-account-designs",
    data() {
        return {
            uploadedImages: [],
            selected: [],
            allSelected: false,
            imageIds: [],
            user_selected_values: [],
            active_gender: "",
            active_gender_key: 0,
            canvas_elements: [],
            deleteIcon: true,
            isLoader: false,
            searchedKeyword: "",
            listConfig: {
                searchKeyword: "",
                offset: (this.currentPage - 1) * this.itemsPerPage,
                limit: this.itemsPerPage,
                sortBy: "",
                order: "ASC",
                order_type: "all"
            },
            item_length: 0,
            currentPage: 1,
            itemsPerPage: 10,
            total_uploaded_images: 0,
            preview_artwork_images: "",
            design_images_list: ""
        };
    },
    components: {},
    beforeMount() {},
    mounted() {
        /* eslint-disable */
        $(function () {
            $("#item2").click(function () {
                $("#submenu2").slideToggle(500);
            });
        });
        /* eslint-enable */
        var _this = this;
        _this.listConfig = {
            searchKeyword: "",
            offset: (_this.currentPage - 1) * _this.itemsPerPage,
            limit: _this.itemsPerPage,
            sortBy: "",
            order: "ASC"
            // order_type: "all"
        };
        _this.UploadedImages();
    },
    computed: {
        pages() {
            if (this.item_length <= this.itemsPerPage) {
                return [1];
            }
            return [
                ...Array(Math.ceil(this.item_length / this.itemsPerPage)).keys()
            ].map((e) => e + 1);
        }
    },
    watch: {
        currentPage(newValue) {
            this.listConfig.offset = (newValue - 1) * this.itemsPerPage;
            this.UploadedImages();
        }
    },
    methods: {
        getData() {
            this.isLoader = true;
            //get saved designs
            ApiService.post("/savedDesigns")
                .then(({ data }) => {
                    this.savedDesigns = data.savedDesigns;
                    this.isLoader = false;
                })
                .catch(({ response }) => {
                    console.log(response);
                });
        },
        selectAll: function () {
            this.imageIds = [];

            if (!this.allSelected) {
                for (var image in this.uploadedImages) {
                    this.imageIds.push(
                        this.uploadedImages[image].id.toString()
                    );
                }
            }
        },
        select: function () {
            this.allSelected = false;
            if (this.uploadedImages.length - 1 == this.imageIds.length) {
                this.allSelected = true;
            }
        },
        deleteDesign(design_id) {
            this.designIds.push(design_id.toString());
            this.deletesavedDesigns();
        },
        deletesavedDesigns() {
            if (confirm("Do you really want to delete?")) {
                new Promise(() => {
                    ApiService.post("/delete_saveddesigns", {
                        ids: this.designIds
                    })
                        .then(() => {
                            this.$toast.success(
                                "Designs deleted successfully",
                                {
                                    position: "top-right"
                                }
                            );
                            this.designIds = [];
                            this.getData();
                        })
                        .catch(() => {});
                });
            }
        },
        setDesign(saved_design) {
            var canvas = new fabric.Canvas("tcanvas", {
                hoverCursor: "pointer",
                selection: true,
                selectionBorderColor: "blue"
            });
            //set canvas objects while selecting design
            this.canvas_elements = "";
            localStorage.setItem(
                "canvas_elements",
                JSON.stringify(this.canvas_elements)
            );
            let product_details = saved_design.product_details;
            let values = [];
            this.user_selected_values = [];
            this.product_title = saved_design["product_title"];
            this.product_id = saved_design.id;
            this.design_name = saved_design.design_name;
            this.base_price = saved_design.retail_base_price;
            let gender = product_details[0].gender;
            let pro_value = new Array();
            pro_value.push({
                product_title: saved_design["product_title"],
                product_id: saved_design.id,
                design_name: saved_design.design_name,
                base_price: saved_design.retail_base_price,
                product_details: saved_design
            });
            product_details.forEach((element) => {
                values.push({
                    [element.gender]: JSON.parse(element.canvas_objects)
                });
                this.genders.push(element.gender);
                this.user_selected_values.push({
                    color: element.color_name,
                    color_hash: element.color_hash,
                    qty: element.qty,
                    total_cost: element.total_cost,
                    total_qty: element.total_qty,
                    gender: element.gender
                });
            });
            localStorage.setItem("product_values", JSON.stringify(pro_value));
            localStorage.setItem(
                "user_selected_values",
                JSON.stringify(this.user_selected_values)
            );
            this.canvas_elements = values;
            localStorage.setItem(
                "canvas_elements",
                JSON.stringify(this.canvas_elements)
            );
            this.active_gender = gender;
            this.active_gender_key = 0;
            localStorage.setItem("active_gender", gender);
            localStorage.setItem("active_gender_key", 0);
            // document.querySelector('#shirtDiv').style.background=this.user_selected_values[0].color_hash;
            if (
                this.canvas_elements[this.active_gender_key][this.active_gender]
                    .length > 0
            ) {
                this.canvas_elements[this.active_gender_key][
                    this.active_gender
                ].forEach((element) => {
                    if (
                        element.type == "template" ||
                        element.type == "shape" ||
                        element.type == "patch" ||
                        element.type == "upload"
                    ) {
                        if (
                            element.flip == localStorage.getItem("active_flip")
                        ) {
                            fabric.Image.fromURL(
                                element.url,
                                function (image) {
                                    image.set({
                                        id: element.id,
                                        left: element.left,
                                        top: element.top,
                                        angle: element.angle,
                                        padding: element.padding,
                                        cornersize: element.cornersize,
                                        hasRotatingPoint: true
                                    });

                                    canvas.add(image);
                                },
                                null,
                                { crossOrigin: "Anonymous" }
                            );
                        }
                    }
                });
            }
            window.location.href = "/design-studio";
        },
        UploadedImages(pagereset = false) {
            var _this = this;
            if (pagereset) {
                _this.currentPage = 1;
                _this.listConfig.offset = 0;
            }
            _this.isBusy = true;
            new Promise(() => {
                ApiService.post("get-design-image-v2", _this.listConfig)
                    .then(({ data }) => {
                        this.uploadedImages = data.design;
                        _this.total_uploaded_images = data.count;
                        _this.item_length = data.count;
                    })

                    .catch(({ response }) => {
                        if (response.status == 401) {
                            _this.$router.push({ name: "/client/login" });
                        }
                    });
            });
        },
        deleteImages() {
            if (confirm("Do you really want to delete?")) {
                new Promise(() => {
                    ApiService.post("/delete_canvasimages", {
                        ids: this.imageIds
                    })
                        .then(() => {
                            this.$toast.success("Images deleted successfully", {
                                position: "top-right"
                            });
                            this.imageIds = [];
                            this.allSelected = false;
                            this.UploadedImages();
                        })
                        .catch(({ response }) => {
                            //  console.log(response.status);
                            if (response.status == 401) {
                                this.$router.push({ name: "/client/login" });
                            }
                        });
                });
            }
        },
        logout() {
            var _this = this;
            this.$store.dispatch(LOGOUT).then(() => {
                _this.$toast.success("Logout Successfully", {
                    position: "top-right"
                });
                this.$router.push({ path: "/" });
            });
        },
        isValidHttpUrl(string) {
            let url;
            try {
                url = new URL(string);
            } catch (_) {
                return false;
            }
            return url.protocol === "http:" || url.protocol === "https:";
        },
        getUrlExtension(url) {
            if (!url) {
                return false;
            }
            return url.split(/[#?]/)[0].split(".").pop().trim();
        },
        previewArtworkImages(images) {
            this.preview_artwork_images = images.front_image;
            if (
                this.getUrlExtension(images.front_image) == "ai" ||
                this.getUrlExtension(images.front_image) == "eps"
            ) {
                /* eslint-disable */
                $("#preview_modals").modal("hide");
                /* eslint-enable */
                this.downloadURI(this.preview_artwork_images, "text.eps");
                this.$toast.success("Files downloaded successfully", {
                    position: "top-right",
                    queue: true
                });
            }
        },
        downloadURI(uri, name) {
            var link = document.createElement("a");
            link.download = name;
            link.href = uri;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            // delete link;
        }
    }
};
</script>
<style scoped>
button.add_artwork_preview_popup_btn {
    z-index: 1;
    position: relative;
}
.upload_img_cont .seen {
    left: 38%;
    top: 26%;
    position: absolute !important;
    display: none;
    border: none;
    background: #fff;
    border-radius: 12px;
}
.upload_img_cont:hover .seen {
    display: block;
}
.upload_img_cont .seen img {
    width: 50px !important;
}
</style>
